<template>
  <div :id="`question_${index + 1}`" class="py-4 flex">
    <span class="w-20 py-5 px-6 text-3xl leading-relaxed absolute transform -translate-y-3 lg:translate-y-0"
          :class="{ [correctClass]: examTypeQuiz }"
    >{{ index + 1 }}</span>
    <div :class="[
      'min-w-0 py-3 flex-1 lg:pl-20 lg:py-5',
      [ isMobile ? 'pl-20' : 'pl-14' ]
    ]">
      <template>
        <div class="-ml-20 pl-20 flex items-start gap-x-1">
          <p class="w-full rounded-lg py-2.5 px-5 bg-gray-100">{{ question.questionTitle }}</p>
          <div class="flex items-center gap-x-0.5"
               v-if="examTypeQuiz"
          >
            <GrmTextField type="number" :value="question.questionScore" class="w-20" disabled />
            <span class="text-xs">{{ $t('exam.question.point') }}</span>
          </div>
        </div>
      </template>
      <div class="mt-2 flex flex-col gap-y-1 relative">
        <div v-for="(answer, i) in questionAnswerListWithUserAnswer"
             :key="answer.answerId"
             class="flex items-center gap-x-1"
        >
          <div class="question min-w-0 max-w-max flex-1 rounded py-1 flex gap-x-2 items-baseline">
            <div v-if="question.questionType === 'CHOICE'" class="relative">
              <button class="number w-5 h-5 border rounded-full flex justify-center items-center text-sm select-none transition pointer-events-none"
                      :class="[answer.userAnswer?.answerId ? 'border-blue-400 bg-blue-400 text-white' : 'border-gray-800']"
              >{{ i + 1 }}</button>
              <span v-if="answer.correct" class="w-5 h-5 bg-exam-check-red block absolute -top-2.5 -left-0.5 pointer-events-none" />
            </div>
            <p class="min-w-0 max-w-max flex-1 rounded-lg py-2 px-3 bg-gray-100 text-xs">{{ answer.answerTitle }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GrmTextField from "@/components/Common/textField/GrmTextField.vue";
import {Device} from "@/utils";

export default {
  name: 'TestbankHistoryQuestionChoice',
  components: {
    GrmTextField,
  },
  props: {
    index: { type: Number, default: 0 },
    question: { type: Object, default: () => ({}), required: true },
    examTypeQuiz: { type: Boolean, default: false }
  },
  computed: {
    correctClass() {
      const { correctAnswerCnt, userCorrectAnswerCnt } = this.question;
      if (
        !!userCorrectAnswerCnt
        && !!correctAnswerCnt
        && userCorrectAnswerCnt === correctAnswerCnt
      ) {
        return 'bg-exam-mark-correct';
      } else if (!userCorrectAnswerCnt) {
        return 'bg-exam-mark-wrong';
      } else {
        return 'bg-exam-mark-part';
      }
    },
    questionAnswerListWithUserAnswer() {
      return this.question.answerList.map((answer) => {
        if (!this.question.userAnswerList) {
          return answer;
        }

        const userAnswer = this.question.userAnswerList.find((userAnswer) => {
          return userAnswer.answerId === answer.answerId
        });
        if (userAnswer) {
          return {
            ...answer,
            userAnswer,
          };
        } else {
          return answer;
        }
      });
    },
    isMobile(){
      return Device.isMobile();
    },
  },
}
</script>